// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"9cab9ea4","282":"edeaa500","334":"c8165daf","357":"72f35656","383":"08fd534c","456":"62e349c1","488":"67fd1452","802":"085eeb40","864":"856747fe","924":"f326b6cb"}[chunkId] + ".chunk.js";
};